/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export const createBundle = (namespace: { [key: string]: string }, translateObj: { [key: string]: object }) => {
  const bundle: { [key: string]: object } = {};
  for (const ns in namespace) {
    bundle[namespace[ns]] = translateObj[namespace[ns]];
  }

  return bundle;
};
